import type { Connection } from '../Connection.js';
import { setHTML, esc } from '../dom.js';
import { openHowToPlay } from './HowToPlayModal.js';

export function renderLobbyScreen(
  container: HTMLElement,
  conn: Connection,
  savedToken: string,
  savedUsername: string,
): void {
  const returning = !!savedToken && !!savedUsername;
  const buttonLabel = returning ? 'Continue Voyage' : 'Sign the Ship\'s Articles';
  setHTML(container, `
    <div class="lobby">
      <h1 class="title">Real Seas!</h1>
      <p class="subtitle">A Pirate's Adventure, in Real Time</p>
      <form id="lobby-form">
        <label for="name">Captain's name</label>
        <input type="text" id="name" name="name" maxlength="24" required autocomplete="off" value="${esc(savedUsername)}" />
        <button type="submit" class="primary">${esc(buttonLabel)}</button>
      </form>
      <p style="margin-top: 24px; font-size: 0.9rem; color: var(--ink-faint); font-style: italic;">
        An action packed adventure on the high seas!
      </p>
      <button class="secondary" id="howto-btn" style="margin-top: 16px;">How to Play</button>
    </div>
  `);
  const input = container.querySelector<HTMLInputElement>('#name')!;
  input.focus();
  input.select();

  const form = container.querySelector<HTMLFormElement>('#lobby-form')!;
  form.onsubmit = (e) => {
    e.preventDefault();
    const username = input.value.trim();
    if (!username) return;
    conn.send({ type: 'join', token: savedToken, username });
  };

  container.querySelector<HTMLButtonElement>('#howto-btn')!.onclick = openHowToPlay;
}
